import React from 'react';
import { connect } from 'react-redux';
import {
  getMenus,
  publishMenu,
  finishPublishMenu,
  deleteMenu,
  finishDeleteMenu,
  createMenu,
  editMenu,
  finishCreateMenu,
  finishEditMenu,
  clearMenuErrors,
} from '../../store/menu/actions';
import { finishSetMerchant } from '../../store/merchant/actions';

function withMenu(WrappedComponent) {
  const mapStateToProps = state => ({
    menus: state.menu.menus,
    menuPersisted: state.menu.menu,
    isLoadingMenus: state.menu.isLoading,
    menuError: state.menu.error,
    menuDeleteError: state.menu.deleteError,
    menuCreated: state.menu.menu,
    isPublishMenuFinished: state.menu.isPublishMenuFinished,
    isDeleteMenuFinished: state.menu.isDeleteMenuFinished,
    isCreateMenuFinished: state.menu.isCreateMenuFinished,
    isEditMenuFinished: state.menu.isEditMenuFinished,
  });

  const mapDispatchToProps = dispatch => ({
    getMenus: () => dispatch(getMenus()),
    finishSetMerchant: () => dispatch(finishSetMerchant()),
    finishPublishMenu: () => dispatch(finishPublishMenu()),
    finishDeleteMenu: () => dispatch(finishDeleteMenu()),
    finishCreateMenu: () => dispatch(finishCreateMenu()),
    finishEditMenu: () => dispatch(finishEditMenu()),
    publishMenu: (published, menu) => dispatch(publishMenu(published, menu)),
    deleteMenu: id => dispatch(deleteMenu(id)),
    createMenu: menu => dispatch(createMenu(menu)),
    editMenu: menu => dispatch(editMenu(menu)),
    clearMenuErrors: () => dispatch(clearMenuErrors()),
  });

  const MenuContainer = props => {
    return <WrappedComponent {...props} />;
  };

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(MenuContainer);
}

function withMenus(WrappedComponent) {
  /* eslint-disable react/prop-types */
  const MenuContainer = props => <WrappedComponent {...props} />;
  /* eslint-enable */

  return withMenu(MenuContainer);
}

export { withMenu, withMenus };



// WEBPACK FOOTER //
// ./src/containers/Menus/index.js